import { Map } from 'immutable';

import {
  UPLOAD_MEDICAL_CERTIFICATE_REQUEST,
  UPLOAD_MEDICAL_CERTIFICATE_FAILURE,
  UPLOAD_MEDICAL_CERTIFICATE_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: [],
});

function reducer(state = initialState, action) {
  const { type } = action;

  if (type === UPLOAD_MEDICAL_CERTIFICATE_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], []);
  }

  if (type === UPLOAD_MEDICAL_CERTIFICATE_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === UPLOAD_MEDICAL_CERTIFICATE_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
